<template>
  <div>
    <!--  参与量化弹出框ß-->
    <van-popup :style="{  width: '80%' }"  v-model="$store.state.showNotice" round class="dpop">
    <div class="popLh">
      <div class="d2">
        <div class="d3">
          <img src="../assets/img/img20.png" alt="" class="d4">
          {{ langUtil(67) }}
        </div>
<!--        <a href="../assets/img/escrow_agreement.pdf" download="escrow_agreement.pdf" target="_blank">-->
<!--          <span style="color:blue;font-size: 13px;">{{ langUtil(110) }}</span>-->
<!--        </a>-->
<!--        <img src="../assets/img/img21.png" alt="" class="d5" @click="$router.push('/community')">-->
      </div>
      <div class="message">
        <div class="img">
          <img src="../assets/img/imglock.png">
        </div>
        <p>
          {{langUtil(139)}}
        </p>
        <div class="message_submit">
          <van-button class="but b1" @click="$store.commit('setState',{showNotice: false})">{{langUtil(69)}}</van-button>
          <van-button class="but b2" @click="$store.commit('setState',{showNotice: false});$router.push('/home')">{{langUtil(115)}}</van-button>
        </div>

      </div>

    </div>
    </van-popup>

  </div>
</template>

<script>
import {showTotalData} from "../tools/index"
import {Toast} from 'vant';
import {depositPool2, contractAbiAllowance, contractAbiApprove} from "../tools/chain";
import {contractAddress} from "../config";

export default {
  name: "getNotice",
  data() {
    return {

    }
  },
  methods: {
    showTotalData(data) {
      return showTotalData(data)
    },
  }
}
</script>

<style lang="less" scoped>
.popLh {
  padding: 15px 15px 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.d2 {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 15px;

  .d3 {
    display: flex;
    align-items: center;
    font-size: 14px;
    font-weight: 300;
    color: black;
  }

  .d4 {
    width: 18px;
    height: 18px;
    margin-right: 8px;
  }
}

.message{
  h3{
    text-align: center;
    margin-bottom: 20px;
  }
  .img{text-align: center;margin-bottom: 20px;}
  p{line-height: 1.7;color: #333;margin-bottom: 30px;}
}
.message_submit{
  display: flex;
  justify-content: space-between;
  .but{width: 48%;}
  .b1{}
  .b2{
    background: #B9EC54;
  }
}


</style>
